/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function ProjectCategoryEditDialogHeader({ id }) {
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { projectCategoryForEdit, actionsLoading } = useSelector(
    (state) => ({
      projectCategoryForEdit: state.projectCategory.projectCategoryForEdit,
      actionsLoading: state.channels.actionsLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : "Tambah Kategori Penyaluran";
    if (projectCategoryForEdit && id) {
      _title = "Edit Kategori Penyaluran";
    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [projectCategoryForEdit, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
    </>
  );
}
